// Author YuJiaBei
// Date 2022-01-26 16:47:52

import * as model from "@/model/em/opcClient/EmOpcComputedEocModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmOpcComputedEoc(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_OPCCLIENT_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emOpcComputedEoc',
        modelFilter: model.filter
    })
    .buildStore()
